import React from 'react';

import ManageCourseTable from '../TableManage';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ManageCourseTable />
    </div>
  );
};
